import { connect, MapDispatchToProps, MapStateToProps } from 'react-redux';
import { pushModal } from '@wix/da-shared-react/pkg/Modals/redux/actionCreators';
import { ModalType } from '@wix/da-shared-react/pkg/Modals/redux/types';
import { Props } from './DefaultLayout';
import { AppState } from '../../../../types/store';
import {
  getActiveSection,
  getHasResults,
  getIsUploadPage,
} from '../../../../selectors/studio';

export type StateProps = Pick<
  Props,
  | 'activeSection'
  | 'maxCapacity'
  | 'freeCapacity'
  | 'hasDeviations'
  | 'linkUploadToStudio'
>;
export type DispatchProps = Pick<Props, 'onPresetsClick'>;
export type OwnProps = Omit<Props, keyof (StateProps & DispatchProps)>;

const mapStateToProps: MapStateToProps<
  StateProps,
  OwnProps,
  AppState
> = state => ({
  activeSection: getActiveSection(state),
  freeCapacity: state.studio!.freeCapacity,
  maxCapacity: state.studio!.maxCapacity,
  hasDeviations: getHasResults(state),
  linkUploadToStudio: !getIsUploadPage(state),
});

const mapDispatchToProps: MapDispatchToProps<
  DispatchProps,
  OwnProps
> = dispatch => ({
  onPresetsClick: () => dispatch(pushModal(ModalType.STUDIO_PRESETS, {})),
});

export default connect(mapStateToProps, mapDispatchToProps);
